import { combineAttributeStrings } from 'utils';

export const getDateInputLabel = ({ label = '', required = false }) => {
  if (label.endsWith('*')) {
    return label;
  }

  return combineAttributeStrings(label, required ? '*' : undefined);
};
